import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Container from '../../../Container/Container';

import {
  TXTCLI_Country_of_Residence,
  TXTSRV_The_XXappXdomainXX_client_is_n_ELL,
  TXTWCL_XXBrandXX_not_available
} from './SignupBlockedCountry.messages.json';

interface Props {
  onBackClick?: () => void;
}

const SignupBlockedCountry: React.FC<Props> = ({ onBackClick }) => (
  <Container
    page={SignupBlockedCountry}
    headerProps={{
      title: <Translation {...TXTCLI_Country_of_Residence} />,
      buttons: { back: true, onBackClick }
    }}
    pageTopTitle={<Translation {...TXTWCL_XXBrandXX_not_available} />}
    pageTopSubtitle={<Translation {...TXTSRV_The_XXappXdomainXX_client_is_n_ELL} />}
  />
);

SignupBlockedCountry.displayName = 'SignupBlockedCountry';

export default SignupBlockedCountry;
